import { render, staticRenderFns } from "./BaseCalendar.vue?vue&type=template&id=b4d4cab6&"
import script from "./BaseCalendar.vue?vue&type=script&lang=ts&"
export * from "./BaseCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports